export default __webpack_public_path__ + "static/media/freshdrinks.d31a7b93.jpeg";